import { Config, SkeletonConfig } from 'features/change-config';
import { useFormContext } from 'react-hook-form';
import type { PostgresConfigWithInstances } from '@/enteties/postgresql/model';
import { projectConfiguration } from '@/enteties/config/api';
import { useServiceType } from 'widgets/project-creation-stepper/providers/service-provider';
import { useEffect } from 'react';
import { useQueryWithOnError } from 'shared/hooks/query/useQueryWithOnError';
export const ConfigFormSetter = () => {
  const {
    reset
  } = useFormContext<PostgresConfigWithInstances>();
  const {
    projectSlug
  } = useServiceType();
  const {
    data,
    isSuccess,
    isLoading
  } = useQueryWithOnError({
    ...projectConfiguration.getProjectConfigQueryOptions({
      slug: projectSlug
    }),
    select: data => {
      const values = data;
      if (values?.run?.servicePort) delete values?.run?.servicePort;
      return values;
    }
  });
  useEffect(() => {
    if (isSuccess) reset(data);
  }, [isSuccess]);
  if (isLoading) return <SkeletonConfig variant="model" />;
  return <Config variant="model" fields="model" slug={projectSlug} data-sentry-element="Config" data-sentry-component="ConfigFormSetter" data-sentry-source-file="config-form-setter.tsx" />;
};